import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PatientData } from '../../types/patient-data';
import { RestApiService } from '../../../services/rest-api.service';
@Component({
  selector: 'app-jor-form-viewer.SomeClass',
  templateUrl: './jot-form-viewer.component.html'
})
export class JotFormViewerComponent implements OnInit {
  @Input() blob: Blob;
  @Input() fileName: string;
  @Input() agencyId: number;
  @Input() currentPatient: PatientData;
  jotUrl: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    public modal: NgbActiveModal,
    private restApi: RestApiService
  ) {}

  ngOnInit(): void {
    this.blob.text().then(async text => {
      const metadata = await this.getPatientMetadata();
      
      // Build metadata parameters first
      let metadataParams = '';
      if (metadata && metadata.metadata && typeof metadata.metadata === 'object') {
        for (const [key, value] of Object.entries(metadata.metadata)) {
          metadataParams += `&${key}=${encodeURIComponent(String(value))}`;
        }
      }
      
      let urlWithParams =
        text +
        '?facilityId=' +
        this.agencyId +
        metadataParams +
        '&camId=' +
        this.currentPatient.email +
        '&name[first]=' +
        this.currentPatient.firstName +
        '&name[last]=' +
        this.currentPatient.lastName;
      console.log('blob.text()' + urlWithParams);
      this.jotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        urlWithParams
      );
    });

    // console.log(this.blobUrl);
    // this.jotUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
    // console.log("jotUrl: " + this.jotUrl);
  }

  viewDocument() {
    this.blob.text().then(text => {
      console.log('blob.text()' + text);
      window.open(
        this.sanitizer.bypassSecurityTrustResourceUrl(text).toString(),
        '_blank'
      );
    });
  }

  close() {
    this.modal.close();
  }

  async getPatientMetadata(): Promise<any> {
    try {
      return await this.restApi.getPatientMetadata();
    } catch (error) {
      console.error('Error fetching patient metadata:', error);
      throw error;
    }
  }

  static showJotForm(
    modals: NgbModal,
    blob: Blob,
    fileName: string,
    agencyId: number,
    currentPatient: PatientData
  ) {
    const modal = modals.open(JotFormViewerComponent, {
      windowClass: 'maximized-modal',
      backdrop: 'static'
    });
    (modal.componentInstance as JotFormViewerComponent).blob = blob;
    (modal.componentInstance as JotFormViewerComponent).fileName = fileName;
    (modal.componentInstance as JotFormViewerComponent).agencyId = agencyId;
    (modal.componentInstance as JotFormViewerComponent).currentPatient = currentPatient;
  }
}
